import React from 'react';
import {
    Box,
    ScaleFade,
    useColorModeValue,
    useDisclosure,
} from '@chakra-ui/react';
import SideNav from './SideNav';
import MobileDrawer from './MobileDrawer';
import MainContextBox from './MainContextBox';
import RedirectIfNotLoggedIn from './../../Shared/RedirectIfNotLoggedIn/RedirectIfNotLoggedIn';

interface IMainWrapper {
    sidebarcomponent: any,
    switchcomponent: any
}

export const MainWrapperContext = React.createContext<any>({} as IMainWrapper);

export default function MainWrapper(props: IMainWrapper) {

    const sidebar = useDisclosure();

    return (
        <MainWrapperContext.Provider
            value={{
                sidebarcomponent: props.sidebarcomponent,
                switchcomponent: props.switchcomponent,
                sidebar: sidebar
            }}>
            <ScaleFade initialScale={0.1} in>
                <Box as="section" bg={useColorModeValue('gray.50', 'gray.700')} minH="100vh"
                >
                    <RedirectIfNotLoggedIn />
                    <Box display={{ base: 'none', md: 'unset' }}>
                        <SideNav />
                    </Box>
                    <MainContextBox sidebar={sidebar} />
                    <MobileDrawer sidebar={sidebar} />
                </Box>
            </ScaleFade>
        </MainWrapperContext.Provider>
    );
}